const isRatingScale = (schema: JSONSchema) =>
  schema.properties?.hasOwnProperty("rows") &&
  schema.properties?.hasOwnProperty("cols");

const schemaTitleToHtml = (schema: JSONSchema, headingLevel: number) =>
  schema.title ? `<h${headingLevel}>${schema.title}</h${headingLevel}>` : "";

const schemaDescriptionToHtml = (schema: JSONSchema) =>
  schema.description ? `<p>${schema.description}</p>` : "";

const arrayToHtmlList = (array: string[]) =>
  `<ul>${array
    .filter((line) => line.length > 0)
    .map((line) => `<li>${line}</li>\n`)}</ul>`;

const noteTextPrimitiveToHtml = (schema: JSONSchema, value: any) => {
  if (value && typeof value !== "string") {
    return "";
  }

  return [
    `<p>`,
    schemaTitleToHtml(schema, 3),
    schemaDescriptionToHtml(schema),
    value ?? "",
    `</p>`,
  ]
    .filter((line) => line.length > 0)
    .join("\n");
};

const noteArrayPrimitiveToHtml = (schema: JSONSchema, value: any) => {
  if (!Array.isArray(value)) {
    return "";
  }

  return [
    `<p>`,
    schemaTitleToHtml(schema, 3),
    schemaDescriptionToHtml(schema),
    arrayToHtmlList(value),
    `</p>`,
  ]
    .filter((line) => line.length > 0)
    .join("\n");
};

const noteSectionToHtml = (schema: JSONSchema, value: any) => {
  const sectionElements = value
    ? Object.entries(schema.properties ?? {}).map(([key, subSchema]) =>
        noteElementToHtml(subSchema, value[key]),
      )
    : "";

  return [
    `<p>`,
    schemaTitleToHtml(schema, 2),
    schemaDescriptionToHtml(schema),
    ...sectionElements,
    `</p>`,
  ]
    .filter((line) => line.length > 0)
    .join("\n");
};

const ratingScaleToHtml = (schema: JSONSchema, value: any) => {
  if (typeof value !== "object") {
    return "";
  }

  return [
    `<p>`,
    schemaTitleToHtml(schema, 3),
    schemaDescriptionToHtml(schema),
    arrayToHtmlList(
      Object.entries(value).map(([key, value]) => `${key}: ${value}`),
    ),
    `</p>`,
  ]
    .filter((line) => line.length > 0)
    .join("\n");
};

const noteElementToHtml = (schema: JSONSchema, value: any) => {
  if (!schema) {
    return "";
  }

  switch (schema.type) {
    case "object": {
      if (isRatingScale(schema)) {
        return ratingScaleToHtml(schema, value);
      }
      return noteSectionToHtml(schema, value);
    }
    case "string": {
      return noteTextPrimitiveToHtml(schema, value);
    }
    case "array": {
      return noteArrayPrimitiveToHtml(schema, value);
    }
    default: {
      return "[Unsupported element]";
    }
  }
};

export default noteElementToHtml;
